module.exports = __webpack_public_path__ + "media/images/borne de recharge pour les véhicules électriques-9315a317247adbfa9f6dda79c3046173.svg";